const getHistoricValue = (IS_HISTORIC: boolean | string | null) => {
  const isHistoricTrue = !!IS_HISTORIC && ["true", true].includes(IS_HISTORIC);
  const isHistoricFalse =
    !!IS_HISTORIC && ["false", false].includes(IS_HISTORIC);

  return isHistoricTrue ? true : isHistoricFalse ? false : null;
};

export default getHistoricValue;
